import { BlockUi } from './../../auth/_helpers/block-ui';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Vet } from './../../auth/_models/vet';
import { VetsService } from './../../auth/_services/vets.service';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { ActivatedRoute } from '@angular/router';
import { AppointmentService } from './../../auth/_services/appointment.service';
import { Appointment } from './../../auth/_models/appointment';
import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { Subject, Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { Pet } from 'src/app/auth/_models/pet';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

enum APPOINTMENT_STATUS {
  PENDING = 0,
  CANCELED = 1,
  FINISHED = 2,
}

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#FF7043',
    secondary: '#FDF1BA'
  }
};

@Component({
  selector: 'app-pet-make-appointment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pet-make-appointment.component.html',
  styleUrls: ['./pet-make-appointment.component.css'],
  providers: [AppointmentService, VetsService]
})

export class PetMakeAppointmentComponent implements OnInit {
  @ViewChild('modalContent')
  modalContent: TemplateRef<any>;

  formNewAgenda: FormGroup;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.appointments = this.appointments.filter(iEvent => iEvent !== event);
        this.handleEvent('Deleted', event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();

  appointments: any[] = [];

  activeDayIsOpen = true;

  pet: Pet;

  newAppointment: Appointment;

  appointmentToEdit: Appointment;

  vets: Vet[];

  disableSchedule = false;

  locale = 'pt';

  public Editor = ClassicEditor;

  public model = {
    editorData: ''
  };

  constructor(
    private _formBuilder: FormBuilder,
    private modal: NgbModal,
    private _blockui: BlockUi,
    private _petsService: PetsService,
    private _appointmentService: AppointmentService,
    private _vetsService: VetsService,
    private _route: ActivatedRoute) {
    this.appointmentToEdit = new Appointment();

    this.formNewAgenda = _formBuilder.group({
      vetName: [null, [Validators.required]],
      dateTime: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    this._route.parent.params.subscribe(params => {
      this._petsService.getPetById(params['id']).subscribe(pet => {
        this.pet = pet;
        this.updateEventList();
      });
    });

    this._vetsService.getVets().subscribe(vets => {
      this.vets = vets;
    });
  }

  updateEventList() {
    this._appointmentService.getAppointments(this.pet).subscribe(appointments => {
      this.appointments = appointments;
      this.refresh.next();
    });
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  eventTimesChanged({ event, newStart, newEnd }: any): void {
    event.start = newStart;
    event.end = newEnd;
    // this.handleEvent('Dropped or resized', event);

    this._appointmentService.editAppointment(this.pet,

      {
        uuid: event.uuid,
        start: event.start,
        end: event.end
      }

    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });

  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  addAppointment() {
    this._blockui.block();
    const controls = this.formNewAgenda.controls;
    this.disableSchedule = true;
    const dateStart = new Date(controls.dateTime.value);

    const dateEnd = new Date(controls.dateTime.value);
    dateEnd.setHours(dateStart.getHours() + 1);

    const vet = this.vets.find(x => x.uuid === controls.vetName.value);

    this._appointmentService.insertAppointment(this.pet,

      {
        title: this.pet.name + ' - ' + dateStart.toLocaleTimeString() + ' - Dr(a). ' + vet.name,
        comments: '',
        start: dateStart,
        end: dateEnd,
        color: colors.yellow,
        draggable: false,
        status: APPOINTMENT_STATUS.PENDING,
        resizable: {
          beforeStart: false,
          afterEnd: false
        },
        vetName: vet.name,
        vetId: vet.uuid
      }

    )
      .then(ok => {
        this.updateEventList();
        this.disableSchedule = false;
        this.formNewAgenda.reset();
        this._blockui.unblock();
      })
      .catch(error => {
        this.disableSchedule = false;
        this.formNewAgenda.reset();
        this._blockui.unblock();
      });

  }

  finishAppointment() {
    this._appointmentService.editAppointment(this.pet,
      {
        uuid: this.appointmentToEdit.uuid,
        title: this.pet.name + ' - Finalizado',
        color: colors.blue,
        status: APPOINTMENT_STATUS.FINISHED,
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  cancelAppointment() {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: this.appointmentToEdit.uuid,
        title: this.pet.name + ' - Cancelado',
        color: colors.red,
        status: APPOINTMENT_STATUS.CANCELED,
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });

  }

  // TODO: verifica se a data escolhida está disponível
  checkAppointmentDate() {

  }

  setAppointmentToEdit(appointmentToEdit: Appointment) {
    this.appointmentToEdit = appointmentToEdit;
    this.model.editorData = appointmentToEdit.comments;
  }

  editAppointmentTitle(event, appointment) {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        title: event.target.value,
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });

  }

  editAppointmentComments(text, appointment) {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        comments: text,
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  editAppointmentVet(event, appointment) {

    const vet = this.vets.find(x => x.uuid === event.target.value);

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        title: this.pet.name + ' - ' + appointment.start.toLocaleTimeString() + ' - Dr(a). ' + vet.name,
        vetName: vet.name,
        vetId: vet.uuid
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  editAppointmentStart(event, appointment) {

    const newStart = new Date(event.target.value);
    const newEnd = new Date();
    newEnd.setDate(newStart.getDate());
    newEnd.setHours(newStart.getHours() + 1);
    newEnd.setMinutes(newStart.getMinutes());

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        title: this.pet.name + ' - ' + newStart.toLocaleTimeString() + ' - Dr(a). ' + appointment.vetName,
        start: newStart,
        end: newEnd
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  editAppointmentEnd(event, appointment) {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        end: new Date(event.target.value),
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  editAppointmentColorPrimary(event, appointment) {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        color: {
          primary: event.target.value,
        }
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

  editAppointmentColorSecondary(event, appointment) {

    this._appointmentService.editAppointment(this.pet,
      {
        uuid: appointment.uuid,
        color: {
          secondary: event.target.value,
        }
      }
    )
      .then(ok => {
        this.refresh.next();
      })
      .catch(error => {
        console.log(error);
      });
  }

}
